/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ keyType: NonNullable<unknown> }} Client_Pix_Key_Type_LabelInputs */

const en_client_pix_key_type_label = /** @type {(inputs: Client_Pix_Key_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.keyType === "cpf") return /** @type {LocalizedString} */ (`CPF`);
	if (i?.keyType === "cnpj") return /** @type {LocalizedString} */ (`CNPJ`);
	if (i?.keyType === "email") return /** @type {LocalizedString} */ (`Email`);
	if (i?.keyType === "phone") return /** @type {LocalizedString} */ (`Phone`);
	if (i?.keyType === "random") return /** @type {LocalizedString} */ (`Random Key`);
	return /** @type {LocalizedString} */ (`${i?.keyType}`)
	
};

const pt_br2_client_pix_key_type_label = /** @type {(inputs: Client_Pix_Key_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.keyType === "cpf") return /** @type {LocalizedString} */ (`CPF`);
	if (i?.keyType === "cnpj") return /** @type {LocalizedString} */ (`CNPJ`);
	if (i?.keyType === "email") return /** @type {LocalizedString} */ (`E-mail`);
	if (i?.keyType === "phone") return /** @type {LocalizedString} */ (`Telefone`);
	if (i?.keyType === "random") return /** @type {LocalizedString} */ (`Chave Aleatória`);
	return /** @type {LocalizedString} */ (`${i?.keyType}`)
	
};

/**
* | keyType | output |
* | --- | --- |
* | "cpf" | "CPF" |
* | "cnpj" | "CNPJ" |
* | "email" | "Email" |
* | "phone" | "Phone" |
* | "random" | "Random Key" |
* | * | "{keyType}" |
*
* @param {Client_Pix_Key_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_pix_key_type_label = /** @type {((inputs: Client_Pix_Key_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Pix_Key_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_pix_key_type_label(inputs)
	return pt_br2_client_pix_key_type_label(inputs)
});